/* PIPS-DOCK-01 (2026-10-05, owner: "Move pips icon on live theme back to bottom corner" +
   "make pips icon disappear when scrolling").
   The concierge app's own stylesheet pins the launcher mid-screen on phones (bottom: calc(50% + 4px))
   and, measured 2026-10-05, beats every theme stylesheet rule — including !important ones — while an
   inline style with priority "important" wins. So this file sets inline styles:
   - phones (<= 767px): full round launcher in the bottom-right corner, above the tab bar
     (--sz-pips-nav-height is kept current by sz-rd.js);
   - every width: fades the launcher out while the page scrolls and back in ~600 ms after it stops.
   Never touches the launcher while the chat is open (.is-open) or focused. Remove this file and the
   one <script> line in layout/sz-redesign.liquid to revert. */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var BARS = '.sz-pm-pdp [data-sz-pm-grade-sticky], .sz-mm__dock';
  var idle, hidden = false;
  function launcher() { return document.getElementById('sz-concierge-launcher') || document.querySelector('.sz-concierge-launcher'); }
  function busy(l) { return l.classList.contains('is-open') || l.contains(document.activeElement); }
  /* QA 2026-10-06: docked bottom-right, the launcher sat on top of the phone signup sheet's button
     and the open menu. Step aside while any overlay is open. */
  function overlayOpen() {
    var h = document.documentElement, bd = document.body;
    if (bd && bd.classList.contains('sz-rd-menu-open')) return true;
    if (h.classList.contains('sz-signup-open') || h.classList.contains('sz-rd-search-open')) return true;
    /* PIPS-POPUP-01 (owner 2026-10-09 "Pips icon shouldn't appear when pop up in mobile window"): side sheets, the photo
       zoom and the cart panel set these classes on <html>. */
    if (h.classList.contains('sz-pm-sheet-open') || h.classList.contains('sz-rd-cartqv-open') || h.classList.contains('sz-rd-menu-open')) return true;
    var qv = document.querySelector('[data-sz-rd-cartqv]'); if (qv && !qv.hidden && qv.classList.contains('is-open')) return true;
    var more = document.getElementById('sz-mobile-more'); if (more && more.open) return true;
    if (document.querySelector('.sz-pm-shop.is-filters-open, .sz-rd-signup.is-open, dialog[open]')) return true;
    /* MOBILE-PDP-01 (2026-10-09): on phones the launcher sat on the cart page's order total; the cart has its own contact links. */
    if (mq.matches && /^\/cart\/?$/.test(location.pathname)) return true;
    return false;
  }
  /* QA 2026-10-06: on phones the open menu is sized from the header (sz-rd-header-compact.css:
     max-height calc(100dvh - 100%)), so with groups expanded it ran past the screen and its last
     entries (Auctions & Deals, Tank Talk) could only scroll to a spot under the tab bar. Cap it at the
     space between its top edge and the tab bar while it is open. */
  function fitMenu() {
    var m = document.querySelector('[data-sz-rd-menu]'); if (!m) return;
    var open = document.body && document.body.classList.contains('sz-rd-menu-open');
    if (open && mq.matches && !m.classList.contains('sz-dr')) {
      var nav = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sz-pips-nav-height')) || 56;
      var room = Math.floor(window.innerHeight - m.getBoundingClientRect().top - nav - 8);
      if (room > 120) m.style.setProperty('max-height', room + 'px', 'important');
    } else if (m.style.getPropertyValue('max-height')) m.style.removeProperty('max-height');
  }
  function syncOverlay() {
    fitMenu();
    var l = launcher(); if (!l || busy(l)) return;
    if (overlayOpen()) { l.style.setProperty('opacity', '0', 'important'); l.style.setProperty('visibility', 'hidden', 'important'); l.style.setProperty('pointer-events', 'none', 'important'); l.setAttribute('data-sz-overlay-hidden', '1'); }
    else if (l.hasAttribute('data-sz-overlay-hidden')) { l.removeAttribute('data-sz-overlay-hidden'); show(); }
  }
  function dock() {
    var l = launcher(); if (!l) return;
    /* QUICK-FIX 2026-10-09: phones keep the launcher hidden until it has been docked once (sz-pm-fixes.css), so a slow
       load never shows it mid-screen and then drops it to the corner (a 0.042 layout shift measured on iPhone 13). */
    l.setAttribute('data-sz-docked', '1');
    if (overlayOpen()) { syncOverlay(); }
    var set = function (k, v) { l.style.setProperty(k, v, 'important'); };
    if (mq.matches) {
      set('top', 'auto'); set('left', 'auto'); set('right', '12px');
      /* BUYBAR-DESK-01 QA (2026-10-09): on product pages the phone buy bar (about 65px) replaces the tab bar, so the
         launcher sat on the right end of Add to bag. Sit 12px above whichever bar is at the bottom. */
      /* LIVE-QA-1014 #6: the same goes for the Mix & Bundle "Review selection" dock (sticky, 80px up), so any bar in
         BARS that is showing in the bottom 200px of the screen lifts the launcher 12px above its top edge. */
      var lift = 0;
      document.querySelectorAll(BARS).forEach(function (bb) {
        if (bb.hidden || !bb.offsetHeight) return;
        var r = bb.getBoundingClientRect();
        if (r.bottom > window.innerHeight - 200 && r.top < window.innerHeight) lift = Math.max(lift, window.innerHeight - r.top);
      });
      if (lift > 0) set('bottom', (lift + 12) + 'px');
      else set('bottom', 'calc(var(--sz-pips-nav-height, 55px) + 12px)');
      /* 48px (was 56): still a full touch target, but covers less of the text under it on a 375px screen */
      set('width', '48px'); set('height', '48px'); set('min-width', '48px');
      set('border-radius', '50%'); set('border-right', ''); set('transform', 'none');
    } else {
      ['top', 'left', 'right', 'bottom', 'width', 'height', 'min-width', 'border-radius', 'transform'].forEach(function (k) { l.style.removeProperty(k); });
    }
  }
  function hide() {
    var l = launcher(); if (!l || busy(l)) return;
    if (!hidden) { l.style.setProperty('transition', 'opacity .18s ease, visibility .18s ease', 'important'); hidden = true; }
    l.style.setProperty('opacity', '0', 'important'); l.style.setProperty('visibility', 'hidden', 'important'); l.style.setProperty('pointer-events', 'none', 'important');
  }
  function show() {
    var l = launcher(); if (!l) return;
    if (overlayOpen()) return; // an open overlay keeps it hidden
    l.style.setProperty('opacity', '1', 'important'); l.style.setProperty('visibility', 'visible', 'important'); l.style.removeProperty('pointer-events');
  }
  /* SCROLL-SYNC-1015: the bubble used to fade on ANY scroll and return 600 ms after the finger stopped, on its own clock.
     It now follows the page's one direction cue (sz-rd.js announces `sz:scrolldir` after 24 px down / 48 px up, the same
     rule that moves the top strip): down = tuck away, up = come back; it still returns 600 ms after scrolling stops. */
  window.addEventListener('scroll', function () { clearTimeout(idle); idle = setTimeout(function () { dock(); show(); }, 600); }, { passive: true });
  document.documentElement.addEventListener('sz:scrolldir', function (e) {
    if (e.detail && e.detail.dir === 'down') hide(); else { dock(); show(); }
  });
  mq.addEventListener ? mq.addEventListener('change', dock) : mq.addListener(dock);
  window.addEventListener('resize', function () { dock(); fitMenu(); }, { passive: true });
  window.addEventListener('load', function () { setTimeout(dock, 300); });
  // the app injects the launcher after load; dock it as soon as it exists
  var tries = 0, t = setInterval(function () { if (launcher() || ++tries > 60) { clearInterval(t); dock(); } }, 250);
  document.addEventListener('DOMContentLoaded', dock);
  var redock = 0;
  new MutationObserver(function () {
    if (launcher() && !launcher().hasAttribute('data-sz-docked')) { launcher().setAttribute('data-sz-docked', '1'); dock(); }
    /* a bar in BARS can appear without a scroll (Mix & Bundle renders its dock on the first pick) */
    else if (mq.matches && !redock && document.querySelector('.sz-mm__dock')) redock = setTimeout(function () { redock = 0; dock(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
  // overlays announce themselves through classes / hidden / open attributes
  new MutationObserver(syncOverlay).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'open'] });
})();
